<bzg-modal-header>
    <div class="bmc-package-maintenance-window__header">
        <span class="bz-color--theme-400">{{ 'DEPLOYMENT.MAINTENANCE_WINDOW_TITLE' | translate }}
        </span>
        <bzg-button-icon icon="icon-close" (click)="close()"></bzg-button-icon>
    </div>
</bzg-modal-header>
<bzg-modal-content>
    <p>
        {{ 'DEPLOYMENT.MAINTENANCE_WINDOW_TEXT' | translate }}
        <span class="bmc-package-maintenance-window__text-underline" (click)="confirm()">
            {{ 'DEPLOYMENT.MAINTENANCE_WINDOW_TEXT_HERE' | translate }}
        </span>
    </p>
    <div *ngIf="data.objectList && data.objectList.length" class="bmc-package-maintenance-window__container">
        <div class="bz-space--stack-s">
            <strong>{{ 'DEPLOYMENT.OBJECT_LIST' | translate }}</strong>
        </div>
        <ul class="bmc-package-maintenance-window__object-list">
            <li *ngFor="let object of data.objectList">- {{object}}</li>
        </ul>
    </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
    <bzg-button-primary (click)="confirm()">{{ 'DEPLOYMENT.MAINTENANCE_WINDOW_BUTTON_CONFIG' | translate }}
    </bzg-button-primary>
</bzg-modal-footer>